<template>
    <div>
        <PullDown></PullDown>
        <Carousel></Carousel>
        <Products :bg='background[2]' class="backgroundNone px-xs-32"></Products>
        <Info :bg='background[0]' class="backgroundNone px-xs-32 px-360"></Info>
        <Num :bg='background[1]'></Num>
        <NewsPart :bg='background[3]' class="backgroundNone px-xs-32"></NewsPart>
        <Honor :bg='background[4]' class="backgroundNone px-xs-32"></Honor>
        <RightFix></RightFix>
    </div>
</template>

<script>
import Carousel from '@/components/header/bannerCarousel.vue'
import Info from '@/components/home/info.vue'
import Num from '@/components/home/num.vue'
import Products from '@/components/home/products.vue'
import NewsPart from '@/components/home/newsPart.vue'
import Honor from '@/components/home/honor.vue'
import RightFix from '@/components/home/rightFix.vue'
import PullDown from '@/components/home/pullDown.vue'

export default {
    data(){
        return{
            background: [require('@/assets/bgInfo.png'),
                        require('@/assets/bgNum.png'),
                        require('@/assets/bgPro.png'),
                        require('@/assets/bgNews.png'),
                        require('@/assets/bgHonor.png')]
        }
    },
    components:{
        Carousel,
        Info,
        Num,
        Products,
        NewsPart,
        Honor,
        RightFix,
        PullDown
    }
}
</script>

<style lang="scss" scoped>
</style>